import React, { useState } from 'react';
import { DesktoOutlined,AppstoreOutlined, DesktopOutlined, MenuFoldOutlined, MenuUnfoldOutlined ,DatabaseOutlined} from '@ant-design/icons';
import { Button, Menu } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import logo from "../assets/Logo black.svg";
import "../assets/Style/navbar.css";
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserDoctor } from '@fortawesome/free-solid-svg-icons';
import {IconBuilding, IconHierarchy, IconUsers, IconFile, IconStethoscope, IconWorld, IconChecklist, IconDeviceDesktop, IconWheelchair,
  IconAppWindow, IconReport , IconCreditCard, IconShieldCheck, IconCalendarEvent, IconReportMedical, IconHeartHandshake,IconMoodSearch ,
  IconClipboardList, IconFileCode
} from '@tabler/icons-react';
const ProjectNavbar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const projectId = useSelector((state) => state.customer.currentProjectId);
  const iconStyle = { fontSize: '18px', display: 'flex', alignItems: 'center', justifyContent: 'center' };
  // Use a function to determine the selected menu key based on pathname
  const getSelectedKey = () => {
    const path = location.pathname;

    if (path.includes('/batch')) {
      return `/project/batch/${projectId}`;
    }
    if (path.includes('/files')) {
      return `/project/files/${projectId}`;
    }
    if (path.includes('/department')) {
      return `/project/department/${projectId}`;
    }
    if (path.includes('/physician')) {
      return `/project/physician/${projectId}`;
    }
    if (path.includes('/state')) {
      return `/project/state/${projectId}`;
    }
    if (path.includes('/payer')) {
      return `/project/payer/${projectId}`;
    }
    if (path.includes('/rules')) {
      return `/project/rules/${projectId}`;
    }
    if (path.includes('/patient')) {
      return `/project/patient/${projectId}`;
    }
    if (path.includes('/insurance')) {
      return `/project/insurance/${projectId}`;
    }
    if (path.includes('/visit')) {
      return `/project/visit/${projectId}`;

    }
    if (path.includes('/encounter')) {
      return `/project/encounter/${projectId}`;
    }
    if (path.includes('/diagnosis')) {
      return `/project/diagnosis/${projectId}`;
    }
    if (path.includes('/service')) {
      return `/project/service/${projectId}`;
    }
    if (path.includes('/icd')) {
      return `/project/icd/${projectId}`;
    }
    if (path.includes('/cpt')) {
      return `/project/cpt/${projectId}`;
    }
    if (path.includes('/hcpc')) {
      return `/project/hcpc/${projectId}`;
    }
    if (path.includes('/claims')) {
      return `/project/claims/${projectId}`;
    }
    return `/project/assignees/${projectId}`; 
  };

  const selectedKey = getSelectedKey();

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  // Define the menu items
  const items = [
    {
      key: `/project/batch/${projectId}`,
      icon: <IconDeviceDesktop style={iconStyle} />,
      label: <Link to={`/project/batch/${projectId}`}>Batch</Link>,
    },
    {
      key: `/project/files/${projectId}`, 
      icon: <IconFile style={iconStyle} />,
      label: <Link to={`/project/files/${projectId}`}>Files</Link>,
    },
    {
      key: `/project/assignees/${projectId}`,
      icon: <IconUsers style={iconStyle} />,
      label: <Link to={`/project/assignees/${projectId}`}>Assignees</Link>,
    },
    {
      key: `/project/department/${projectId}`,
      icon: <IconBuilding style={iconStyle} />,
      label: <Link to={`/project/department/${projectId}`}>Department</Link>,
    },
    {
      key: `/project/physician/${projectId}`,
      icon: <IconStethoscope style={iconStyle} />,
      label: <Link to={`/project/physician/${projectId}`}>Physician</Link>,
    },
    {
      key: `/project/state/${projectId}`,
      icon: <IconWorld style={iconStyle} />,
      label: <Link to={`/project/state/${projectId}`}>State</Link>,
    },
    {
      key: `/project/payer/${projectId}`,
      icon: <IconCreditCard style={iconStyle} />,
      label: <Link to={`/project/payer/${projectId}`}>Payer</Link>,
    },
    {
      key: `/project/icd/${projectId}`,
      icon: <IconClipboardList style={iconStyle} />,
      label: <Link to={`/project/icd/${projectId}`}>ICD</Link>,
    },
    {
      key: `/project/cpt/${projectId}`,
      icon: <IconFileCode style={iconStyle} />,
      label: <Link to={`/project/cpt/${projectId}`}>CPT</Link>,
    },
    {
      key: `/project/hcpc/${projectId}`,
      icon: <IconReport  style={iconStyle} />,
      label: <Link to={`/project/hcpc/${projectId}`}>HCPC</Link>,
    },
    {
      key: `/project/rules/${projectId}`,
      icon: <IconChecklist style={iconStyle} />,
      label: <Link to={`/project/rules/${projectId}`}>Rules</Link>,
    },
    {
      key: `/project/patient/${projectId}`,
      icon: <IconWheelchair style={iconStyle} />,
      label: <Link to={`/project/patient/${projectId}`}>Patient</Link>,
    },
    {
      key: `/project/insurance/${projectId}`,
      icon: <IconShieldCheck style={iconStyle} />,
      label: <Link to={`/project/insurance/${projectId}`}>Insurance</Link>,
    },
    {
      key: `/project/visit/${projectId}`,
      icon: <IconCalendarEvent style={iconStyle} />,
      label: <Link to={`/project/visit/${projectId}`}>Visit</Link>,
    },
    {
      key: `/project/encounter/${projectId}`,
      icon: <IconMoodSearch  ethoscope style={iconStyle} />,
      label: <Link to={`/project/encounter/${projectId}`}>Encounter</Link>,
    },
    {
      key: `/project/diagnosis/${projectId}`,
      icon: <IconReportMedical style={iconStyle} />,
      label: <Link to={`/project/diagnosis/${projectId}`}>Diagnosis</Link>,
    },
    {
      key: `/project/service/${projectId}`,
      icon: <IconHeartHandshake style={iconStyle} />,
      label: <Link to={`/project/service/${projectId}`}>Service</Link>,
    },
   
    {
      key: `/project/claims/${projectId}`,
      icon: <IconReport  style={iconStyle} />,
      label: <Link to={`/project/claims/${projectId}`}>Claims</Link>,
    },
  ];

  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflowY:"auto",
        width: collapsed ? 80 : 200,
        transition: 'width 0.2s',
        backgroundColor: '#fff',
        borderRight: '1px solid #e8e8e8',
        margin: '0',
        padding: '0',
      }}
    >
      <div className="logo-container">
        <img
          src={logo}
          alt="Logo"
          className="logo"
        />
      </div>

      {/* <Button
        type="primary"
        onClick={toggleCollapsed}
        style={{
          margin: '5px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '0',
        }}
      >
        {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
      </Button> */}
      <Menu
        defaultSelectedKeys={[selectedKey]} // Highlight the correct menu based on route
        selectedKeys={[selectedKey]} // Dynamically update the selected item
        mode="inline"
        inlineCollapsed={collapsed}
        items={items}
        style={{ flex: 1 }}
      />
    </div>
  );
};

export default ProjectNavbar;
